import { DateFromToFilter, FilterLabelProps } from "@duosoftbg/nacid-components";
import * as React from "react";

const LastUpdateDateFilter = ({ label = "l.searchFilter.lastUpdateDate", ...others }: FilterLabelProps) => {
  return <DateFromToFilter label={label} from={"lastUpdateDateFrom"} to={"lastUpdateDateTo"} {...others} />;
};

export default LastUpdateDateFilter;
